import { MsalInstance } from '@trukt/auth-web/MsalInstance';

export const msalInstance = new MsalInstance({
  clientId: import.meta.env.VITE_CLIENT_ID,
  policy: import.meta.env.VITE_POLICY,
});
